<template>
  <v-stepper :value="step">
    <v-stepper-header>
      <v-stepper-step :complete="step > 1" step="1">{{ $t('shipmentStep1') }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="step > 2" step="2">{{ $t('shipmentStep2') }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">{{ $t('shipmentStep3') }}</v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  name: 'ShipmentStepperComp',

  props: {
    step: {
      required: true
    }
  },

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
